import baseAPI from '@/http'

const router = 'api/usuario'

export const userAPI = {
  create: (user) => baseAPI.post(router + '/cadastrar-usuario', user),
  update: (user) => baseAPI.put(router, user),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  listConsultant: () => baseAPI.get(router + '/consultores'),
  recuperarSenha: (user) => baseAPI.post(router + '/recuperar-senha', user),
  trocarSenha: (user) => baseAPI.post(router + '/trocar-senha', user),
  updateUser: (user) => baseAPI.put(router + '/atualizar-usuario', user),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listADs: () => baseAPI.get(router + '/ads'),
  getByCPF: (cpf) => baseAPI.get(`${router}/get-by-cpf/${cpf}`),
  sendSignature: (user) => baseAPI.post(router + '/enviar-assinatura-eletronica', user),
  getByFilter: (filtro) => baseAPI.post(router + '/get-by-filtro', filtro),
  testePDF: () => baseAPI.get(`${router}/teste-pdf`, { responseType: 'blob' }),
  trocarSenhaPrimeiroAcesso: (filtro) => baseAPI.post(router + '/trocar-senha-primeiro-acesso', filtro)
}
